module.exports = __webpack_public_path__ + "media/assets/community_index/open-4bef9a2c47dfaf8073dfb1481f2a1c07e43292c47633c097677e1cca3feea93f.svg";